/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1CreateTaxoparkWithdrawalSecretResponse } from '../../entities/v1/CreateTaxoparkWithdrawalSecretResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1CreateTaxoparkWithdrawalSecretResponseSchema = z.object({
  api_key: z.string(),
}) as unknown as ToZod<V1CreateTaxoparkWithdrawalSecretResponse>